import React from "react";
import s from "./styles.module.scss";

// importing icons
import Logo from "shared/icons/Logo";
import ArrowDown from "./icons/ArrowDown";
import User from "./icons/User";
import { Link, useLocation } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { useAppSelector } from "shared/redux/hooks";
import { mallSelect } from "shared/redux/selectors/mall";
import { userSelect } from "shared/redux/selectors/user";
import Bonuses from "shared/ui/Bonuses";

const Header: React.FC = () => {
  const { pathname } = useLocation();
  const { name } = useAppSelector(mallSelect);
  const { user_info } = useAppSelector(userSelect);

  return (
    <header className={s.header}>
      <div className={s.logo}>
        {pathname === ROUTES_PATH.HOME ? (
          <Logo />
        ) : (
          <Link className={s.link} to={ROUTES_PATH.HOME}>
            <Logo />
          </Link>
        )}

        <Link to={ROUTES_PATH.SELECT_MALL} className={s.select}>
          <div>
            Место встречи:
            <div>{name}</div>
          </div>
          <ArrowDown />
        </Link>
      </div>

      {user_info?.balance !== undefined ? (
        <Link to={ROUTES_PATH.ACCOUNT}>
          <Bonuses count={user_info.balance} />
        </Link>
      ) : (
        <Link to={ROUTES_PATH.REGISTRATION} className={s.login}>
          <User />
        </Link>
      )}
    </header>
  );
};

export default Header;
